import type { IconProps } from '@zinc/ui';
import { Badge, Icon, Tooltip } from '@zinc/ui';

import withDisplayName from 'bz-utilities/hoc/display-name';

import React from 'react';

interface IProps extends React.PropsWithChildren {
  size?: IconProps['size'];
}

const HeidiTooltip = React.memo(
  withDisplayName<IProps>((props: IProps) => {
    const { size } = props;

    return (
      <Tooltip contentGap={2} text={<p className="text-white">{props.children}</p>}>
        {(attributes) => (
          <Badge variant="faded" color="neutral" size="small" attributes={attributes} rounded>
            <Icon
              color="neutral-faded"
              size={size ?? 5}
              svg={<img src={'/images/heidi-logo.svg'} />}
            />
          </Badge>
        )}
      </Tooltip>
    );
  }, 'HeidiTooltip')
);

export default HeidiTooltip;
